import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { ClarityModule } from '@clr/angular';
import { Row } from 'src/app/models/ui/table';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';

@Component({
  selector: 'app-all-selected-btn',
  template: `
    <clr-tooltip>
      <cds-icon clrTooltipTrigger shape="stop" [solid]="!isAllSelected()" />
      <clr-tooltip-content [clrPosition]="position()" [clrSize]="'md'">
        {{ (isAllSelected() ? 'Auswahl löschen' : 'Alle auswählen') | mrTranslate }}
      </clr-tooltip-content>
    </clr-tooltip>
  `,
  host: {
    class: 'btn btn-icon',
    'data-testid': 'all-selected-btn',
    '(click)': 'toggleAllSelected()',
    '[class.disabled]': 'isEmpty()',
  },
  imports: [ClarityModule, MrTranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllSelectedBtnComponent {
  protected readonly selected = model.required<Row[]>();
  protected readonly all = input.required<Row[]>();
  protected readonly position = input<'bottom-left' | 'bottom-right'>('bottom-left');

  protected readonly isEmpty = computed(() => !this.all().length);
  protected readonly isAllSelected = computed(() => !this.isEmpty() && this.selected().length == this.all().length);

  protected toggleAllSelected() {
    this.selected.set(this.isAllSelected() ? [] : [...this.all()]);
  }
}
